document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-rr-menu]');
  if (!button) return;
  const menu = document.querySelector('[data-rr-links]');
  const open = menu?.classList.toggle('is-open');
  button.setAttribute('aria-expanded', String(Boolean(open)));
  document.body.classList.toggle('vg-nav-open', Boolean(open));
});

/* Collection type filters (?tipo=) */
(function () {
  const root = document.querySelector('[data-vg-collection]');
  if (!root) return;
  const cards = [...root.querySelectorAll('[data-vg-type]')];
  if (!cards.length) return;
  const params = new URLSearchParams(window.location.search);
  const tipo = params.get('tipo') || '';
  const countEl = root.querySelector('[data-vg-collection-count]');
  const emptyEl = root.querySelector('[data-vg-filter-empty]');
  let shown = 0;
  cards.forEach((card) => {
    const match = !tipo || card.getAttribute('data-vg-type') === tipo;
    card.hidden = !match;
    if (match) shown += 1;
  });
  if (countEl && tipo) countEl.textContent = shown + ' prodotti';
  if (emptyEl) emptyEl.hidden = !(tipo && shown === 0);
  const reset = root.querySelector('[data-vg-filter-reset]');
  if (reset) reset.hidden = !tipo;
  root.querySelectorAll('[data-vg-type-filter]').forEach((link) => {
    if (link.getAttribute('data-vg-type-filter') === tipo) link.setAttribute('aria-current', 'true');
  });
})();

/* Collection drawers */
(function () {
  const openFilters = document.querySelector('[data-vg-open-filters]');
  const openSort = document.querySelector('[data-vg-open-sort]');
  const filters = document.getElementById('VgFiltersDrawer');
  const sort = document.getElementById('VgSortDrawer');

  function closeAll() {
    [filters, sort].forEach((drawer) => {
      if (!drawer) return;
      drawer.hidden = true;
    });
    openFilters?.setAttribute('aria-expanded', 'false');
    openSort?.setAttribute('aria-expanded', 'false');
  }

  function openDrawer(drawer, trigger) {
    closeAll();
    if (!drawer) return;
    drawer.hidden = false;
    trigger?.setAttribute('aria-expanded', 'true');
  }

  openFilters?.addEventListener('click', () => openDrawer(filters, openFilters));
  openSort?.addEventListener('click', () => openDrawer(sort, openSort));
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-vg-close-drawer]')) closeAll();
    if (event.target.matches('[data-vg-drawer]')) closeAll();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });
})();

/* PDP variant pills + thumbs + sticky ATC */
(function () {
  const root = document.querySelector('[data-vg-pdp]');
  if (!root) return;
  const form = root.querySelector('[data-vg-product-form]') || root.querySelector('form[action*="/cart/add"]');
  const idInput = root.querySelector('[data-vg-variant-id]');
  const variantSelect = root.querySelector('[data-vg-variant-select]');
  const atc = root.querySelector('[data-vg-atc]');
  const priceWrap = root.querySelector('[data-vg-price-wrap]');
  const saleChip = root.querySelector('[data-vg-sale-chip]');
  let pdpBadge = root.querySelector('[data-vg-pdp-badge]');
  if (!pdpBadge) { const mm = root.querySelector('[data-vg-main-media]'); if (mm) { pdpBadge = document.createElement('span'); pdpBadge.className = 'vg-pdp__badge'; pdpBadge.hidden = true; mm.prepend(pdpBadge); } }
  const sticky = document.querySelector('[data-vg-sticky-atc]');
  const stickySubmit = document.querySelector('[data-vg-sticky-submit]');
  const stickyPrice = document.querySelector('[data-vg-sticky-price]');
  const mainMedia = root.querySelector('[data-vg-main-media] img');
  const stockEl = root.querySelector('[data-vg-stock]');

  function money(cents) {
    const value = Number(cents || 0) / 100;
    try { return value.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }); }
    catch (e) { return value.toFixed(2).replace('.', ',') + ' €'; }
  }

  function renderPrice(priceValue, compareValue) {
    const price = Number(priceValue || 0);
    const compare = Number(compareValue || 0);
    const onSale = compare > price && price > 0;
    if (stickyPrice) stickyPrice.textContent = money(price);
    if (saleChip) saleChip.hidden = !onSale;
    if (!priceWrap) return;
    if (onSale) {
      const pct = Math.round(((compare - price) * 100) / compare);
      priceWrap.innerHTML = '<div class="vg-price vg-price--sale"><p class="vg-price__now"><strong>' + money(price) + '</strong> <s class="vg-price__compare">' + money(compare) + '</s></p></div>';
      if (pdpBadge) { pdpBadge.textContent = '−' + pct + '%'; pdpBadge.hidden = !(pct > 0); }
    } else {
      priceWrap.innerHTML = '<div class="vg-price"><p class="vg-price__now"><strong>' + money(price) + '</strong></p></div>';
      if (pdpBadge) pdpBadge.hidden = true;
    }
  }

  function setMainImage(src, srcset) {
    if (!mainMedia || !src) return;
    mainMedia.src = src;
    if (srcset) mainMedia.srcset = srcset;
  }

  function setAvailability(available, qty, tracked) {
    const canBuy = available === true || available === 'true';
    if (atc) { atc.disabled = !canBuy; atc.textContent = canBuy ? 'Aggiungi al carrello' : 'Esaurito'; }
    if (stickySubmit) {
      stickySubmit.disabled = !canBuy;
      stickySubmit.textContent = canBuy ? 'Aggiungi' : 'Esaurito';
    }
    if (stockEl) {
      stockEl.classList.toggle('is-out', !canBuy);
      if (!canBuy) stockEl.textContent = 'Esaurito';
      else if ((tracked === true || tracked === 'true') && Number(qty) > 0 && Number(qty) <= 2) stockEl.textContent = 'Disponibile · ultimi pezzi';
      else stockEl.textContent = 'Disponibile';
    }
  }

  function applyVariant(data) {
    if (!data || !data.variantId) return;
    if (idInput) idInput.value = data.variantId;
    renderPrice(data.price, data.compare);
    setAvailability(data.available, data.qty, data.tracked);
    if (data.mediaSrc) setMainImage(data.mediaSrc, data.mediaSrcset || '');
    if (data.mediaId) {
      root.querySelectorAll('[data-vg-thumb]').forEach((thumb) => {
        thumb.classList.toggle('is-active', String(thumb.dataset.mediaId) === String(data.mediaId));
      });
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', data.variantId);
    window.history.replaceState({}, '', url);
  }

  root.querySelectorAll('[data-vg-variant-pills] button').forEach((btn) => {
    btn.addEventListener('click', () => {
      root.querySelectorAll('[data-vg-variant-pills] button').forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      applyVariant({
        variantId: btn.dataset.variantId,
        price: btn.dataset.price,
        compare: btn.dataset.compare,
        available: btn.dataset.available,
        qty: btn.dataset.qty,
        tracked: btn.dataset.tracked,
        mediaId: btn.dataset.media,
        mediaSrc: btn.dataset.mediaSrc,
        mediaSrcset: btn.dataset.mediaSrcset,
      });
    });
  });

  variantSelect?.addEventListener('change', () => {
    const opt = variantSelect.selectedOptions[0];
    if (!opt) return;
    applyVariant({
      variantId: opt.value,
      price: opt.dataset.price,
      compare: opt.dataset.compare,
      available: opt.dataset.available,
      qty: opt.dataset.qty,
      tracked: opt.dataset.tracked,
      mediaSrc: opt.dataset.mediaSrc,
      mediaSrcset: opt.dataset.mediaSrcset,
    });
  });

  root.querySelectorAll('[data-vg-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input[name="quantity"]');
    if (!input) return;
    wrap.querySelector('[data-vg-qty-minus]')?.addEventListener('click', () => {
      input.value = String(Math.max(1, Number(input.value || 1) - 1));
    });
    wrap.querySelector('[data-vg-qty-plus]')?.addEventListener('click', () => {
      input.value = String(Math.max(1, Number(input.value || 1) + 1));
    });
    input.addEventListener('change', () => {
      input.value = String(Math.max(1, Number(input.value || 1)));
    });
  });

  root.querySelectorAll('[data-vg-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      root.querySelectorAll('[data-vg-thumb]').forEach((t) => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      setMainImage(thumb.dataset.fullSrc, thumb.dataset.fullSrcset || '');
    });
  });

  if (sticky && atc) {
    let atcVisible = true;
    let footerVisible = false;
    const syncSticky = () => {
      const show = !atcVisible && !footerVisible;
      sticky.hidden = !show;
      sticky.classList.toggle('is-on', show);
    };
    const io = new IntersectionObserver((entries) => {
      atcVisible = entries.some((e) => e.isIntersecting);
      syncSticky();
    }, { threshold: 0 });
    io.observe(atc);
    const footer = document.querySelector('.rr-footer');
    if (footer) {
      const fio = new IntersectionObserver((entries) => {
        footerVisible = entries.some((e) => e.isIntersecting);
        syncSticky();
      }, { threshold: 0 });
      fio.observe(footer);
    }
  }
  if (stickySubmit && form) stickySubmit.addEventListener('click', () => { if (!atc?.disabled && !stickySubmit.disabled) form.requestSubmit ? form.requestSubmit() : form.submit(); });
})();

/* Completa l'atmosfera: complementari Shopify espliciti, senza algoritmo generico */
(function () {
  const box = document.querySelector('[data-vg-related]');
  if (!box) return;
  if (box.getAttribute('data-source') === 'explicit') return;
  const url = box.getAttribute('data-url');
  if (!url) return;
  fetch(url)
    .then((response) => response.text())
    .then((html) => {
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-vg-related]');
      if (!next || !next.querySelector('.rr-product')) return;
      next.setAttribute('data-has-cards', 'true');
      next.setAttribute('data-source', 'explicit');
      next.hidden = false;
      box.replaceWith(next);
    })
    .catch(() => {});
})();


/* Newsletter discount code copy */
(function () {
  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-vg-copy-code]');
    if (!btn) return;
    const code = btn.getAttribute('data-vg-copy-code') || '';
    if (!code) return;
    const original = btn.textContent;
    try {
      await navigator.clipboard.writeText(code);
      btn.textContent = 'Copiato ✓';
    } catch (e) {
      const input = document.createElement('input');
      input.value = code;
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      try { document.execCommand('copy'); btn.textContent = 'Copiato ✓'; } catch (_) { btn.textContent = code; }
      input.remove();
    }
    window.setTimeout(() => { btn.textContent = original; }, 2200);
  });
})();

/* Cookie banner + Shopify Customer Privacy */
(function () {
  const root = document.querySelector('[data-vg-cookie-root]');
  if (!root) return;

  const prefs = root.querySelector('[data-vg-cookie-prefs]');
  const customizeBtn = root.querySelector('[data-vg-cookie-customize]');
  const saveBtn = root.querySelector('[data-vg-cookie-save]');
  const analyticsInput = root.querySelector('[data-vg-cookie-analytics]');
  const marketingInput = root.querySelector('[data-vg-cookie-marketing]');
  const KEY = 'vg_artikasa_cookie';

  function hideNativeShopifyBanner() {
    document.querySelectorAll('.shopify-pc__banner, .shopify-pc__prefs, .shopify-pc__prefs__overlay, #shopify-pc-banner, shopify-privacy-banner').forEach((el) => {
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
      el.style.setProperty('display', 'none', 'important');
    });
  }
  hideNativeShopifyBanner();
  const nativeObserver = new MutationObserver(hideNativeShopifyBanner);
  nativeObserver.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => nativeObserver.disconnect(), 20000);

  function markSettled() {
    document.documentElement.setAttribute('data-vg-cookie-state', 'done');
    document.dispatchEvent(new CustomEvent('vg:cookie-settled'));
  }

  function hide() {
    root.hidden = true;
    root.removeAttribute('data-vg-cookie-open');
  }

  function show(expanded) {
    root.hidden = false;
    root.setAttribute('data-vg-cookie-open', 'true');
    if (expanded) expand();
    const focusEl = root.querySelector('[data-vg-cookie-accept], [data-vg-cookie-save]');
    window.setTimeout(() => focusEl?.focus?.(), 30);
  }

  function expand() {
    if (prefs) prefs.hidden = false;
    if (customizeBtn) customizeBtn.hidden = true;
    if (saveBtn) saveBtn.hidden = false;
  }

  function stored() {
    try { return window.localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }

  function remember() {
    try { window.localStorage.setItem(KEY, '1'); } catch (e) {}
  }

  function visitorConsent() {
    try { return window.Shopify?.customerPrivacy?.currentVisitorConsent?.() || null; } catch (e) { return null; }
  }

  function hasShopifyDecision() {
    const c = visitorConsent();
    if (!c) return false;
    return ['analytics', 'marketing'].some((key) => c[key] === 'yes' || c[key] === 'no');
  }

  function syncToggles() {
    const c = visitorConsent();
    if (!c) return;
    if (analyticsInput) analyticsInput.checked = c.analytics === 'yes';
    if (marketingInput) marketingInput.checked = c.marketing === 'yes';
  }

  function apply(consent, done) {
    const payload = {
      analytics: !!consent.analytics,
      marketing: !!consent.marketing,
      preferences: true,
      sale_of_data: false,
    };
    const finish = () => {
      remember();
      hide();
      markSettled();
      if (done) done();
    };
    const api = window.Shopify?.customerPrivacy;
    if (api?.setTrackingConsent) api.setTrackingConsent(payload, finish);
    else finish();
  }

  function ready(fn) {
    if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
      fn();
      return;
    }
    if (!window.Shopify?.loadFeatures) {
      fn();
      return;
    }
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => fn());
  }

  root.querySelector('[data-vg-cookie-accept]')?.addEventListener('click', () => {
    apply({ analytics: true, marketing: true });
  });
  root.querySelector('[data-vg-cookie-reject]')?.addEventListener('click', () => {
    apply({ analytics: false, marketing: false });
  });
  customizeBtn?.addEventListener('click', expand);
  saveBtn?.addEventListener('click', () => {
    apply({
      analytics: !!analyticsInput?.checked,
      marketing: !!marketingInput?.checked,
    });
  });

  document.addEventListener('click', (event) => {
    const openBtn = event.target.closest('[data-vg-cookie-open]');
    if (!openBtn) return;
    syncToggles();
    show(true);
  });

  ready(() => {
    if (hasShopifyDecision() || stored()) {
      hide();
      markSettled();
      return;
    }
    show(false);
  });
})();

/* VG FAQ filters — progressive enhancement: without JS all FAQs remain visible. */
(() => {
  const page = document.querySelector('.rr-page--faq');
  const nav = document.querySelector('.rr-page-hero--faq .rr-faq-hero__nav');
  if (!page || !nav) return;

  const bands = [...page.querySelectorAll(':scope > .rr-inner > .rr-story-band')];
  const groups = new Map();
  let current = null;

  bands.forEach((band) => {
    if (band.id && band.id.startsWith('faq-')) current = band.id;
    if (current) {
      if (!groups.has(current)) groups.set(current, []);
      groups.get(current).push(band);
    }
  });

  const links = [...nav.querySelectorAll('a[href^="#faq-"]')];
  links.forEach((link) => {
    link.setAttribute('role', 'button');
    link.setAttribute('aria-pressed', 'false');
    link.addEventListener('click', (event) => {
      const id = link.getAttribute('href').slice(1);
      if (!groups.has(id)) return;
      event.preventDefault();
      const alreadyActive = link.classList.contains('is-active');

      links.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-pressed', 'false');
      });

      if (alreadyActive) {
        bands.forEach((band) => band.removeAttribute('data-vg-faq-hidden'));
        history.replaceState(null, '', location.pathname + location.search);
        return;
      }

      link.classList.add('is-active');
      link.setAttribute('aria-pressed', 'true');
      bands.forEach((band) => {
        const show = groups.get(id).includes(band) || band.classList.contains('rr-story-band--cta');
        if (show) band.removeAttribute('data-vg-faq-hidden');
        else band.setAttribute('data-vg-faq-hidden', 'true');
      });
      history.replaceState(null, '', `#${id}`);
      page.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    });
  });

  const initial = location.hash;
  if (initial && groups.has(initial.slice(1))) nav.querySelector(`a[href="${initial}"]`)?.click();
})();
